import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useRef } from 'react';
import { VisibilitySensor } from '@/components/functional/Scroll/VisibilitySensor/VisibilitySensor';
import { ChatMessage } from '@/components/modules/Chat/ChatMessage';
/**
 * チャットメッセージコンポーネントをVisibilityCensorでラップ
 * @param props
 * @constructor
 */
export const FoldableListChatMessageWithVisibilitySensor = (props) => {
    const { active, className = '', isShowUnreadBadge, item, onChange: propOnChange, onClickFileLink, partialVisibility, } = props;
    // メッセージが表示されたか判定用
    const isShownRef = useRef(false);
    /** 初回に表示された時だけメッセージを返すイベント */
    const onChange = useCallback((isVisible) => {
        // メッセージが初回表示された時だけイベントを実行する
        if (propOnChange && isVisible && !isShownRef.current) {
            propOnChange(item.messageId);
            isShownRef.current = true;
        }
    }, [propOnChange, item.messageId, isShownRef]);
    return (_jsx(VisibilitySensor, Object.assign({ active: active, onChange: onChange, partialVisibility: partialVisibility }, { children: _jsx(ChatMessage, { className: className, files: item.files, isBox: item.isBox, isShowUnreadBadge: isShowUnreadBadge, message: item.message, onClickFileLink: onClickFileLink, time: item.time, unread: item.unread }) })));
};
